import { api } from "@/lib/api";
import { toast } from "sonner";

export const download = async (path, name, params) => {
  const r = await api.get(path, { params, responseType: "blob" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(r.data);
  a.download = name;
  a.click();
};

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : "Something went wrong";
};

export const call = async (fn, ok) => {
  try { const r = await fn(); if (ok) toast.success(typeof ok === "function" ? ok(r.data) : ok); return r.data; }
  catch (e) { toast.error(errMsg(e)); return null; }
};

export const STATUS_STYLE = {
  pending: "bg-amber-100 text-amber-800", unmatched: "bg-red-100 text-red-700", auto_repaired: "bg-emerald-100 text-emerald-700",
  approved: "bg-emerald-100 text-emerald-700", discontinued: "bg-orange-100 text-orange-800", gone: "bg-slate-200 text-slate-700",
  rejected: "bg-slate-200 text-slate-600", live: "bg-sky-100 text-sky-700", ignored: "bg-slate-100 text-slate-500", new: "bg-slate-100 text-slate-600",
};
export const CONF_STYLE = { high: "text-emerald-700", medium: "text-amber-700", low: "text-red-700" };
